module.exports = __webpack_public_path__ + "img/icon_tips_bg.6e7b6621.png";